import LegalSection from './LegalSection';

function LegalPage() {
  return (
    <>
      <header className="hero legal-hero">
        <div>
          <p className="eyebrow">Site Notice</p>
          <h1>Privacy Policy & Terms</h1>
          <p className="sub">Front-end only single-page app; data stays in your browser. Follow laws and platform policies; avoid inappropriate content.</p>
          <a className="primary" href="#/">
            Back to Home
          </a>
        </div>
      </header>
      <main className="content">
        <LegalSection />
      </main>
    </>
  );
}

export default LegalPage;

